import { Injectable } from '@angular/core';
import { AuthService } from './auth.service';
import { ActivatedRouteSnapshot, Router, RouterStateSnapshot } from '@angular/router';

@Injectable({
  providedIn: 'root'
})
export class AuthGaurdService {

  constructor(private authService: AuthService, private router: Router) { }
  
  canActivate(next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot) {
    if (!this.authService.isLoggedIn()) {
      this.router.navigateByUrl("/login")
    }
    return true
  }
}
